import {
  useIsDesktop,
  useIsWeb,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {
  CommonActions,
  RouteProp,
  useNavigation,
  useRoute,
} from '@react-navigation/native';
import OfferDetailsFlyout from 'components/Offers/OfferDetailsFlyout';
import BlurredOverlay from 'components/Offers/OfferDetailsFlyout/BlurredOverlay';
import ConnectedOfferDetails from 'containers/OfferDetails';
import {Pressable, View} from 'native-base';
import {useDispatch, useSelector} from 'Provider';
import React, {useCallback} from 'react';
import {Platform} from 'react-native';
import {isWebViewSelector} from 'store/content';
import {OffersActions} from 'store/offers/offers.reducer';
import {selectedOfferSelector} from 'store/offers/offers.selectors';

export interface ConnectedOffersOverlayProps {
  children: React.ReactNode;
}

type ParamsList = {
  OffersGrouping: {group: string; offerid?: string};
};

const ConnectedOffersOverlay: React.FunctionComponent<
  ConnectedOffersOverlayProps
> = props => {
  const {children} = props;
  const selectedOffer = useSelector(selectedOfferSelector);

  const route = useRoute<RouteProp<ParamsList, 'OffersGrouping'>>();
  const navigation = useNavigation();
  const isDesktop = useIsDesktop();
  const isWebView = useSelector(isWebViewSelector);
  const isWeb = useIsWeb();
  const dispatch = useDispatch();

  const checkIsDeepLinkingInWebView =
    Platform.OS === 'web' &&
    !isDesktop &&
    isWebView &&
    !!route?.params?.offerid;

  const handleCloseOfferDetails = useCallback(
    (clearParam = true) => {
      dispatch(OffersActions.setSelectedOfferId(undefined));
      dispatch(OffersActions.clearAcceptOCRMOfferState());
      // On offer deselect/close
      const params = route.params;
      if (clearParam && params?.offerid) {
        navigation.dispatch(
          CommonActions.setParams({...params, offerid: undefined})
        );
      }
    },
    [dispatch, navigation, route.params]
  );

  return (
    <>
      {isWeb ? (
        <BlurredOverlay enabled={!!selectedOffer}>{children}</BlurredOverlay>
      ) : (
        <View width="100%" height="100%">
          {children}
        </View>
      )}

      {selectedOffer && !checkIsDeepLinkingInWebView && (
        <Pressable
          height="100%"
          width="100%"
          position="absolute"
          backgroundColor="rgba(0,0,0,0.4)"
          onPress={() => handleCloseOfferDetails(true)}
        />
      )}

      {!!selectedOffer && (
        <OfferDetailsFlyout
          checkIsDeepLinkingInWebView={checkIsDeepLinkingInWebView}
          selectedOffer={selectedOffer}
          showSlideFlyout={!!selectedOffer}>
          <ConnectedOfferDetails
            handleCloseOfferDetails={handleCloseOfferDetails}
          />
        </OfferDetailsFlyout>
      )}
    </>
  );
};

export default ConnectedOffersOverlay;
